(ns app.domain.attachment.file-formats
  (:require [app.domain.group.model :as group-model]
            [clojure.set :as set]))

(def image-convertable-mime-types
  #{:image/tiff
    :image/png
    :image/jpeg
    :image/heic
    :image/heif})

(def always-convertable-mime-types
  #{:image/tiff
    :image/png
    :image/jpeg
    :image/heic
    :image/heif
    :application/vnd.openxmlformats-officedocument.presentationml.presentation
    :application/vnd.openxmlformats-officedocument.wordprocessingml.document
    :application/vnd.oasis.opendocument.text
    :application/vnd.oasis.opendocument.graphics
    :application/vnd.oasis.opendocument.presentation
    :application/vnd.ms-powerpoint
    :application/rtf
    :application/msword
    :text/plain})

(defn get-convertable-mime-types
  "Mime types that are converted to PDF/A"
  [feature-flags domain-group]
  (let [pdfa-conversion-enabled? (or (group-model/has-feature? domain-group :group.feature/pdfa-conversion-for-attachments)
                                     (not (contains? feature-flags :feature-flag.id/pdf-validation-only-by-default)))]
    (cond-> always-convertable-mime-types
      pdfa-conversion-enabled? (conj :application/pdf))))

(def pdf-compatible-mime-types
  "Mime types that are or can be converted to PDF"
  (conj always-convertable-mime-types :application/pdf))

(def extractable-mime-types
  #{:application/zip
    ; Note: Windows uses "application/x-zip-compressed" as zip mime type
    :application/x-zip-compressed})

(def formats-without-preview
  #{:image/heic
    :image/heif
    :application/vnd.openxmlformats-officedocument.presentationml.presentation
    :application/vnd.openxmlformats-officedocument.wordprocessingml.document
    :application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
    :application/vnd.oasis.opendocument.text
    :application/vnd.oasis.opendocument.graphics
    :application/vnd.oasis.opendocument.presentation
    :application/vnd.oasis.opendocument.spreadsheet
    :application/vnd.ms-powerpoint
    :application/rtf
    :application/msword
    :image/svg+xml})

(def convertable-mime-types-inspections
  #{:image/heic
    :image/heif})

(def ifc-mime-types
  #{:application/x-step})

(def video-types
  #{:video/mp4
    :video/webm
    :video/ogg
    :video/x-msvideo
    :video/quicktime
    :video/x-matroska
    :video/x-flv
    :video/avi
    :video/mpeg
    :video/x-ms-wmv
    :video/x-theora})

(def accepted-mime-types-for-attachments
  (set/union pdf-compatible-mime-types
             convertable-mime-types-inspections
             video-types
             #{:image/gif
               :image/vnd.dwg
               :image/x-pict
               :image/svg+xml
               :text/rtf
               :application/x-extension-ifc
               :application/postscript
               :application/zip
               :application/x-zip-compressed
               :application/x-7z-compressed
               :application/vnd.ms-excel
               :application/vnd.oasis.opendocument.spreadsheet
               :application/vnd.openxmlformats-officedocument.spreadsheetml.sheet}))

(def previewable-mime-types
  "Files that can be loaded without the Content-Disposition header"
  (set/difference accepted-mime-types-for-attachments
                  formats-without-preview))

(def all-accepted-mime-types
  (set/union accepted-mime-types-for-attachments
             ifc-mime-types))

(defn- keywords->mime-types [mime-type-keywords]
  (map #(str (namespace %) "/" (name %)) mime-type-keywords))

(def accept-value-for-input
  (->> accepted-mime-types-for-attachments
       keywords->mime-types))

(def convertable-accept-value-for-input
  (keywords->mime-types pdf-compatible-mime-types))

(def condition-attachment-mime-types
  (conj image-convertable-mime-types :application/pdf))

(def condition-attachment-accept-value-for-input
  (keywords->mime-types condition-attachment-mime-types))

(def ifc-file-extension
  ".ifc")
